export default __webpack_public_path__ + "static/media/arrow_down.91b64eb8.svg";